export default __webpack_public_path__ + "static/media/ratingfill.6de8eaa3.svg";